import { render, staticRenderFns } from "./modelClose.vue?vue&type=template&id=31320fe0&scoped=true&"
import script from "./modelClose.vue?vue&type=script&lang=js&"
export * from "./modelClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31320fe0",
  null
  
)

export default component.exports